import { configureStore, createListenerMiddleware } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import authenticationReducer, { logout, loginUser, refreshSession } from "./Features/Authentication/authSlice";
import { apiSlice } from "./Features/api/apiSlice";
import notificationsReducer from "./Global/notifications/notificationsSlice";
import stepperReducer from "./Features/Installer/Stepper/stepperSlice";

import navReducer from "./Features/QE/Nav/navSlice";
function check_if_production() {
  if (process.env.REACT_APP_PRODUCTION == 1) {
    return false;
  }
  else{
    return true;
  }}

// Every sign-out (the menus, any 401 since R4, a refused session refresh) drops the cached API
// data, and so does a sign-in. Nothing reset it, so the next user in the same tab saw the last
// user's jobs and QE lists until a reload (Test Co run 26/10 G4, P3).
const sessionListener = createListenerMiddleware();
sessionListener.startListening({
  predicate: (action) => logout.match(action) || loginUser.fulfilled.match(action)
    || (refreshSession.rejected.match(action) && action.payload === 401),
  effect: (_action, api) => { api.dispatch(apiSlice.util.resetApiState()); },
});

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authenticationReducer,
    notifications: notificationsReducer,
    stepper: stepperReducer,
    nav: navReducer,
  },
  devTools: check_if_production(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(sessionListener.middleware).concat(apiSlice.middleware),
});

// Without this, refetchOnFocus / refetchOnReconnect do nothing: the connection check never
// rechecked when signal came back, and QE Pending never refreshed on its own (P2).
setupListeners(store.dispatch);
